import { apiBaseUrl } from '@utils/Host';
import host from '../host';

export default {
  url_list: `${apiBaseUrl}filemanager/files`,
  url_directories: `${apiBaseUrl}filemanager/directories`,
  url_directories_delete: `${apiBaseUrl}filemanager/directories/recursive`,
  url_image: `${apiBaseUrl}filemanager/images`,
};
